import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f744992"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shipping-details-location" }
const _hoisted_2 = { class: "shipping-details-location__title" }
const _hoisted_3 = { class: "shipping-details-location__selects" }

import BaseArrow from '@/components/base/BaseArrow.vue';
import CountrySelectFrom from '@/v2/CountrySelectFrom.vue';
import CountrySelectTo from '@/v2/CountrySelectTo.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ShippingDetailsLocationV2',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('shippingDetailsLocation_title')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CountrySelectFrom, { class: "shipping-details-location__select" }),
      _createVNode(BaseArrow, {
        length: "20px",
        vertical: "",
        dotted: ""
      }),
      _createVNode(CountrySelectTo, { class: "shipping-details-location__select" })
    ])
  ]))
}
}

})